import { AddToQueueOutlined } from '@mui/icons-material';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const loadStateFromLocalStorage = (): LicitacaoListFiltro => {
  const savedState = localStorage.getItem('licitacaoListFiltro');
  if (savedState) {
    try {
      // Tenta fazer o parse do JSON armazenado
      const parsedState: LicitacaoListFiltro = JSON.parse(savedState);

      // Aqui você pode validar ou manipular os dados, se necessário
      return parsedState;
    } catch (error) {
      console.error('Erro ao ler o estado do localStorage:', error);
      // Retorna o valor inicial caso haja algum erro no parsing
      return ISLicitacaoListFiltro;
    }
  }
  // Caso não haja dados no localStorage, define as datas de início e fim
  const currentYear = new Date().getFullYear();
  const dataInicial = `01/01/${currentYear-5}`;
  const dataFinal = `31/12/${currentYear}`;

  return {
    ...ISLicitacaoListFiltro, // Espalha os valores padrão
    dataInicial,
    dataFinal
  };
};

// Função para gravar o estado no localStorage
export const saveStateToLocalStorage = (state: LicitacaoListFiltro) => {
  try {
    // Convertendo as datas para string ISO antes de salvar

    // Converte o estado para uma string JSON e salva no localStorage
    localStorage.setItem('licitacaoListFiltro', JSON.stringify(state));
  } catch (error) {
    console.error('Erro ao gravar no localStorage:', error);
  }
};

interface LicitacaoListFiltro {
  dataInicial: string | null;
  dataFinal: string | null;
  search: string | '';
  apply: boolean;
}

const ISLicitacaoListFiltro: LicitacaoListFiltro = {
  dataInicial: null,
  dataFinal: null,
  search: '',
  apply: false
};

const licitacaoPublicListFiltroSlice = createSlice({
  name: 'licitacaoPublicListFiltro',
  initialState: loadStateFromLocalStorage,
  reducers: {
    atualizarLicitacaoFiltro: (state, action: PayloadAction<LicitacaoListFiltro>) => {
      //state = action.payload;
       return { ...action.payload }; // ✅ Corrigido
    },
    // Ação para atualizarLicitacao o campo dataInicial
    atualizarLicitacaoDataInicial: (state, action: PayloadAction<string | null>) => {
      state.dataInicial = action.payload;
    },
    // Ação para atualizarLicitacao o campo dataFinal
    atualizarLicitacaoDataFinal: (state, action: PayloadAction<string | null>) => {
      state.dataFinal = action.payload;
    },
    atualizarLicitacaoSearch: (state, action: PayloadAction<string>) => {
    
      state.search = action.payload;
    },
    atualizarLicitacaoApply: state => {
      state.apply = !state.apply;
    },

    resetLicitacao: () => ISLicitacaoListFiltro,

    setLicitacao: (state, action: PayloadAction<LicitacaoListFiltro>) => {
      return { ...state, ...action.payload }; // Atualiza o estado com os dados recebidos
    },
    setLicitacaoStorage: state => {
      saveStateToLocalStorage(state);
    }
  }
});
// Exportando as ações (reducers)
export const {
  atualizarLicitacaoFiltro,
  atualizarLicitacaoDataInicial,
  atualizarLicitacaoDataFinal,
  atualizarLicitacaoSearch,
  resetLicitacao,
  setLicitacao,
  setLicitacaoStorage,
  atualizarLicitacaoApply
} = licitacaoPublicListFiltroSlice.actions;

export default licitacaoPublicListFiltroSlice.reducer;
